import { PAYMENT_GATEWAY, SUBSCRIPTION_STATUS, type Account } from '@adtrackify/at-tracking-event-types';

export const STRIPE_RECOVERY_STATUSES: ReadonlySet<string> = new Set([
  SUBSCRIPTION_STATUS.PAST_DUE,
  SUBSCRIPTION_STATUS.UNPAID,
]);

export function isAccountEffectivelyActive(account: Account | null | undefined): boolean {
  if (!account) return false;
  const status = account.subscription?.status;
  if (!status) return false;

  if (status === SUBSCRIPTION_STATUS.ACTIVE) {
    return true;
  }

  const isStripe = account.subscription?.paymentGateway === PAYMENT_GATEWAY.STRIPE;
  return isStripe && STRIPE_RECOVERY_STATUSES.has(status);
}

export function findEffectivelyActiveAccount(
  accounts: Account[] | null | undefined
): Account | undefined {
  if (!accounts?.length) return undefined;
  return accounts.find(acc => isAccountEffectivelyActive(acc));
}

export function upsertAccountInList(accounts: Account[], account: Account): Account[] {
  const existingIndex = accounts.findIndex(existingAccount => existingAccount.id === account.id);
  if (existingIndex === -1) {
    return [...accounts, account];
  }

  const nextAccounts = [...accounts];
  nextAccounts[existingIndex] = account;
  return nextAccounts;
}
